










import { Component, Vue } from "vue-property-decorator";
import { default as Page } from "./components/Page.vue";

@Component({
	components: {
		Page
	}
})
export default class App extends Vue {}
